import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, Button, Input } from 'reactstrap';
import { FormGroup, Label } from 'reactstrap';
import { useSelector, useDispatch } from "react-redux";

import RobotoRegularFont from "assets/fonts/Roboto-Regular.ttf";
import RobotoBoldFont from "assets/fonts/Roboto-Bold.ttf";
import "assets/stylesheets/Export.css";
import jsPDF from "jspdf";
import $ from "jquery";
import {
  getCanvas,
  getMainBuyplanItems,
  setIsExportPDF,
  getCustomProps,
  updateSelectionCanvasItems,
  handleZoomChange,
  calculateXYWidthHeight,
  isValidDate,
  addPoweredByText,
  addPageNumber,
  addMonthTitle
} from "../Helpers";
import { getCanvasInfo } from "actions/canvasInfoActions.js";
import { getCanvasPath } from "actions/canvasPathActions.js";
import { updateCanvasDetails } from "actions/canvasDetailsActions.js";
import { canvasInfoDataSelector } from "selectors/canvasInfoSelector.js";
import { canvasPathSelector } from "selectors/canvasPathSelector.js";

import Alert from "components/Alert";

import DefaultSampleImage from "assets/images/bannerSampleImage.png";

import { LoaderIcon } from "components/Loader/Loader";
import { bannerInfoDataSelector } from "selectors/bannerInfoSelector.js";
import logoBaseImg from "assets/images/logoBase64.png";
import hrefImg from "assets/images/hrefImg.png";

let selectedMonths = [];
let canvasDataColl = {};
let currentJSON = false;
const bannerImageData = {};
let pdfArrayBuffer = null;

const EmailPDFModal = ({ modal, sortedBuyplanItems, toggleModal, closePopup, currMonth, buyplanId }) => {

  const dispatch = useDispatch();
  const [checkedCP, setCoverPageChecked] = useState(false);
  const [checkedEP, setEndingPageChecked] = useState(false);
  const [isPDFGenerating, setIsPDFGenerating] = useState(false);
  const [showAlertBanner, setShowAlertBanner] = useState(false);
  const [alertMsg, setAlertMsg] = useState('');
  const canvasData = useSelector(canvasInfoDataSelector);
  const canvasPath = useSelector(canvasPathSelector);
  const bannerInfoData = useSelector(bannerInfoDataSelector);

  const today = new Date();
  const curmonth = today.getMonth() + 1;
  const curyear = today.getFullYear();
  const [pdfName, setDynamicPdfName] = useState(`Brandscope Whiteboard_${curmonth}_${curyear}`);

  //get canvas data
  useEffect(() => {
    if (selectedMonths.length && canvasData && canvasData !== "" && canvasData != true) {
      const cData = canvasData.get("canvas_state") ? canvasData.get("canvas_state").get("canvas_state") : null;
      const canvas = getCanvas();
      const zValue = canvas.getZoom() * 100;
      if (cData && canvas) {
        const month = canvasData.get("month");
        if (cData) {
          canvas.loadFromJSON(JSON.stringify(cData), function () {

            const evt = { target: { value: 'FitToCanvas' } }
            handleZoomChange(evt);

            canvas.renderAll.bind(canvas);
            canvas.requestRenderAll();
            canvasDataColl[month] = {};
            canvasDataColl[month]["img"] = canvas.toDataURL("image/png");
            if (Object.keys(canvasDataColl).length === selectedMonths.length) {
              setIsExportPDF(false);
              setTimeout(() => {
                if (currentJSON) {
                  const evt = { target: { value: zValue } }
                  handleZoomChange(evt);
                  canvas.loadFromJSON(JSON.stringify(currentJSON), function () {
                    canvas.renderAll.bind(canvas);
                    canvas.requestRenderAll();
                    currentJSON = false;
                    updateSelectionCanvasItems();
                  });
                }
              }, 100);
              generateDownloadPDF();
              resetParams();
            }
          });
        }
      }
    }
  }, [canvasData]);

  //get canvas path
  useEffect(() => {
    if (pdfArrayBuffer) {
      uploadPDFFile(canvasPath.get("url"));
      pdfArrayBuffer = null;
    }
  }, [canvasPath]);

  function resetParams() {
    selectedMonths = [];
    canvasDataColl = {};
  }

  function convertImgToBase64(url, callback) {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function () {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.height = this.naturalHeight;
      canvas.width = this.naturalWidth;
      bannerImageData.imgwidth = canvas.width;
      bannerImageData.imgheight = canvas.height;
      ctx.drawImage(this, 0, 0);
      const dataURL = canvas.toDataURL('image/jpeg');
      callback(dataURL);
    };
    img.src = url;
  }

  function proceedDownloadPDF() {
    const canvas = getCanvas();

    currentJSON = canvas.toJSON(getCustomProps());

    const buyPlanItems = getMainBuyplanItems();
    const months = [];
    if (buyPlanItems)
      for (let buyplanItem of buyPlanItems.values()) {
        months.push(buyplanItem.get("short_month"))
      }

    //canvas pages
    for (const month of months) {
      if ($("#checkboxfor" + month).prop('checked')) {
        selectedMonths.push(month);
      }
    }

    let banner_url = bannerInfoData.get("banner_url");
    if (!banner_url) {
      banner_url = DefaultSampleImage;
    }
    convertImgToBase64(banner_url, (base64Image) => {
      bannerImageData.img = base64Image;
      generatePDF();
    });
  }

  function generatePDF() {
    setIsPDFGenerating(true);
    if (selectedMonths.length) {
      for (const month of selectedMonths) {
        setIsExportPDF(true);
        dispatch(getCanvasInfo(buyplanId, month));
      }
    } else {
      generateDownloadPDF();
    }
  }

  function generateDownloadPDF() {

    const currentTime = new Date();
    let month = currentTime.getMonth() + 1;
    let selectedMonth
    const canvas = getCanvas();
    const dpr = 1;
    const cwidth = (canvas.width * dpr);
    const cheight = (canvas.height * dpr);
    const pwidth = cwidth + 130 / 2;
    const pheight = cheight + (260 * 4) / 2;

    let pdf = "";
    if (pheight > pwidth) {
      pdf = new jsPDF("portrait", "pt", [pwidth, pheight]);
    } else {
      pdf = new jsPDF("landscape", "pt", [pwidth, pheight]);
    }

    pdf.addFont(RobotoRegularFont, 'Roboto', 'Regular');
    pdf.addFont(RobotoBoldFont, 'Roboto', 'Bold');
    pdf.setFont('Roboto', 'Regular');

    // Get the custom width and height
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight()

    const xMargin = 65 / 2;
    const yMargin = 65 / 2;

    //COVER page
    const release_name = bannerInfoData.get("release_name");
    let pageTitle = $("#pageTitleText").val();
    if (!pageTitle) pageTitle = "Whiteboard";

    const dim = calculateXYWidthHeight(pageWidth, pageHeight / 2, bannerImageData.imgwidth, bannerImageData.imgheight);

    pdf.addImage(bannerImageData.img, "JPEG", dim.x, dim.y, dim.width, dim.height);

    pdf.setFontSize(63 / 2);

    // Text position
    const textX = 80;
    const textY = pageHeight / 2 + xMargin + 20;
    // Add text
    pdf.text(pageTitle, textX, textY);
    // Set dotted line style (dash length, gap length)
    pdf.setLineDash([5, 5], 10);

    // Get text width and height (approximation)
    const titletextWidth = pdf.getTextWidth(pageTitle);
    const lineHeight = 50;

    // Draw a rectangle around the text with a dotted border
    pdf.rect(textX - 15, textY - lineHeight + 15, titletextWidth + 30, lineHeight, 'S');  // 'S' is for Stroke (border)

    if (release_name) {
      pdf.setFontSize(41 / 2);
      pdf.text(release_name.toUpperCase(), textX - 15, textY + 50);
    }

    addPoweredByText(pdf, xMargin, pageWidth, pageHeight, logoBaseImg);

    // Add CANVAS Page
    for (let i = 0; i < selectedMonths.length; i++) {
      month = selectedMonths[i];

      if (canvasDataColl[month] && canvasDataColl[month]["img"]) {
        const monthTitle = $("#textfor" + month).val();

        let path = window.location.href;
        path = path.replace(`/whiteboard/${currMonth}`, '');
        path += `/whiteboard/${month}`;

        pdf.addPage();

        let xPos = xMargin;
        for (selectedMonth of selectedMonths) {
          if (selectedMonth === month) {
            pdf.setFillColor(56, 172, 236);
            pdf.setTextColor(255, 255, 255);
            pdf.rect(xPos, yMargin - 10, pdf.getTextWidth(selectedMonth) + 18, 30, 'F');
            pdf.text(selectedMonth, xPos + 8, yMargin + 10);
          } else {
            pdf.setFillColor(217, 217, 217);
            pdf.setTextColor(255, 255, 255);
            pdf.rect(xPos, yMargin - 10, pdf.getTextWidth(selectedMonth) + 18, 30, 'F');
            pdf.text(selectedMonth, xPos + 8, yMargin + 10);
          }
          xPos += 75;
        }

        addMonthTitle(pdf, pageWidth, xMargin, yMargin, monthTitle);

        const img = canvasDataColl[month]["img"];
        pdf.addImage(img, "PNG", xMargin, 130 / 2, cwidth, cheight);

        pdf.setDrawColor(0);
        pdf.roundedRect(xMargin, 130 / 2, cwidth, cheight, 5, 5, 'S');

        pdf.setTextColor(56, 172, 236);
        // Define the link text and URL
        const linkText = "View in Brandscope";
        const linkURL = path;
        const y = pageHeight - yMargin; // Y coordinate (small margin from the bottom)
        // Add the link text to the PDF
        pdf.text(linkText, xMargin, y);
        const textWidth = pdf.getTextWidth(linkText);
        // Draw an underline (x, y, xEnd, yEnd)
        pdf.setDrawColor(56, 172, 236); // Set the underline color to match the text
        pdf.line(xMargin, y + 3, yMargin + textWidth, y + 3); // Draw the underline slightly below the text
        pdf.link(xMargin, y - 20, textWidth * 2, 40, { url: linkURL });

        pdf.addImage(hrefImg, "JPEG", xMargin + textWidth + 5, y - 8, 10, 10);

        addPageNumber(pdf, xMargin, pageWidth, pageHeight, "PAGE " + (i + 1));
      }
    }

    //Ending page    
    pdf.addPage();
    pdf.setFont('Roboto');
    pdf.setTextColor(0, 0, 0); // RGB values for red

    let bulletPoints = [];
    const notesofRetailer = $("#notesofretailertext").val()
    if (notesofRetailer) {
      bulletPoints = notesofRetailer.split("\n");
    }
    pdf.setFontSize(39 / 2);
    pdf.setFillColor(242, 242, 242);
    pdf.rect(30, yMargin, pdf.getTextWidth('NOTES FOR THE RETAILER') + 30, 50, 'F');
    pdf.setFont('Roboto', 'Bold');
    pdf.text("NOTES FOR THE RETAILER", xMargin + 10, 130 / 2);
    pdf.setFont('Roboto', 'Regular');
    const margin = 45;
    const wrapWidth = pageWidth - margin * 2;
    const lines = pdf.splitTextToSize(notesofRetailer, wrapWidth);
    let notesY = 120;
    pdf.setFontSize(36 / 2);

    // Loop through each line from the textarea and add it to the PDF as a bullet point
    bulletPoints.forEach(retailnotes => {
      if (retailnotes.trim()) {  // Only add non-empty lines
        pdf.text('\u2022 ' + retailnotes.trim(), margin, notesY);
        notesY += 30;  // Move down the Y axis for the next bullet point
      }
    });
    const headtextHeight = lines.length * (pdf.getFontSize() * 1.15);
    let newYPosition = headtextHeight + 10;

    if ($("#deliveryMonthcheckbox").prop('checked')) {
      pdf.setFont('Roboto', 'Bold');
      pdf.setFontSize(39 / 2);
      pdf.setFillColor(242, 242, 242);
      pdf.rect(30, newYPosition + 120, pdf.getTextWidth('DELIVERY MONTH') + 30, 50, 'F');
      pdf.text("DELIVERY MONTH", xMargin + 10, newYPosition + 153);
      pdf.setFontSize(34 / 2);

      let Xxpos = xMargin;
      for (selectedMonth of selectedMonths) {
        pdf.setFillColor(56, 172, 236);
        pdf.setTextColor(255, 255, 255);
        pdf.rect(Xxpos, newYPosition + 185, pdf.getTextWidth(selectedMonth) + 18, 40, 'F');
        pdf.text(selectedMonth, Xxpos + 8, newYPosition + 210);
        Xxpos += 75;
      }

      pdf.setFont('Roboto', 'Regular');
    }

    if ($("#indentDeadLineDatecheckbox").prop('checked')) {
      pdf.setFontSize(39 / 2);
      pdf.setTextColor(0, 0, 0);
      pdf.text("DEADLINE DATES", 30, newYPosition + 330);
      pdf.setFontSize(36 / 2);
      pdf.setTextColor(115, 115, 115);
      pdf.text("2024-07-10", 220, newYPosition + 330);
    }

    addPoweredByText(pdf, xMargin, pageWidth, pageHeight, logoBaseImg);
    const fileName = $("#pdfname").val() + ".pdf";
    pdf.save(fileName);

    pdfArrayBuffer = pdf.output('arraybuffer');
    pdf.close();

    setIsPDFGenerating(false);

    dispatch(getCanvasPath(buyplanId, fileName));

    setAlertMsg('Export PDF Successfully');
    setShowAlertBanner(true);
    setTimeout(() => {
      setShowAlertBanner(false);
    }, 2000);
  }

  // Function to upload file to s3
  const uploadPDFFile = async (presignedUploadUrl) => {

    const pdfHeaders = new Headers({ 'Content-Type': 'application/pdf' });
    const response = await fetch(presignedUploadUrl, {
      method: 'PUT',
      headers: pdfHeaders,
      body: pdfArrayBuffer
    });

    if (!response.ok) {
      return false;
    }

    dispatch(updateCanvasDetails(buyplanId, response.url));
  };

  const pdfNameChange = (event) => {
    setDynamicPdfName(event.target.value); // Update dynamic input state
  };

  return (
    <Modal size={"lg"} isOpen={modal} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal} className="modal-header whiteboardExport" >
        <div className="customHeader">
          <div className="customHeaderTitle">
            Export PDF
          </div>
          <div className="customHeaderButton">
            <Button className="customHeaderCancel" onClick={closePopup}>
              Cancel
            </Button>
            <Button className="customHeaderSend" onClick={proceedDownloadPDF}>
              {isPDFGenerating ? <LoaderIcon /> : null} Export
            </Button>
          </div>
        </div>
      </ModalHeader>
      <ModalBody className="exportPDFModalbody">
        {showAlertBanner &&
          <Alert variant="info"> {alertMsg} </Alert>
        }
        <div className="exportPDFModalDiv">
          <div className='parent_section_7'>
            <div className='child_section'>
              PDF Name *
            </div>
          </div>
          <div className='parent_section_8'>
            <div className='child_section'>
              <Input id="pdfname" type="text" value={pdfName} onChange={pdfNameChange} />
            </div>
          </div>
        </div>
        <FormGroup check className="shortMonthDiv">
          <Input type="checkbox" defaultChecked={checkedCP} id="coverPagePdf" onChange={() => setCoverPageChecked((state) => !state)} />
          <Label check for="coverPagePdf" className="coverPagePdf">
            Cover Page
          </Label>
          {checkedCP === true &&
            <div className="coverPageDiv">
              <div className='parent_section_1'>
                <div className='child_section'>
                  <Label check for="pageTitleCheckbox">
                    Title
                  </Label>
                </div>
              </div>

              <div className='parent_section_2'>
                <div className='child_section'>
                  <Input type="text" id="pageTitleText" />
                </div>
              </div>
            </div>
          }
        </FormGroup>
        <FormGroup check className="shortMonthDiv">
          <Input type="checkbox" defaultChecked={checkedEP} id="endPagePDF" onChange={() => setEndingPageChecked((state) => !state)} />
          <Label check for="endPagePDF" className="endPagePDF">
            Ending Page
          </Label>
          {checkedEP === true &&
            <div>

              <div>
                <div className='parent_section_1'>
                  <div className='child_section'>

                  </div>
                </div>

                <div className='parent_section_2'>
                  <div className='child_section'>
                    <Label>
                      Notes for the Retailers
                    </Label>
                  </div>

                </div>
                <div>
                  <div className='parent_section_3'>
                    <div className='child_section'>
                    </div>
                  </div>
                  <div className='parent_section_4'>
                    <div className='child_section'>
                      <Input type="textarea" id="notesofretailertext" />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <div className='parent_section_1'>
                  <div className='child_section'>
                    <FormGroup check>
                      <Input type="checkbox" id="deliveryMonthcheckbox" />
                    </FormGroup>
                  </div>
                </div>

                <div className='parent_section_2'>
                  <div className='child_section'>
                    <Label check for="deliveryMonthcheckbox">
                      Delivery Month
                    </Label>
                  </div>
                </div>
              </div>

              <div>
                <div className='parent_section_1'>
                  <div className='child_section'>
                    <FormGroup check>
                      <Input type="checkbox" id="indentDeadLineDatecheckbox" />
                    </FormGroup>
                  </div>
                </div>
                <div className='parent_section_2'>
                  <div className='child_section'>
                    <Label check for="indentDeadLineDatecheckbox">
                      Indent Deadline Date
                    </Label>
                  </div>
                </div>
              </div>
            </div>
          }
          <div className="shortMonthDiv">
            {sortedBuyplanItems.entrySeq().map(([formattedDate, buyplanItem]) => {

              const shortMonth = buyplanItem.get("short_month");
              const date = buyplanItem.get("date");

              //Do not show pdf content for previous months
              if (!date || isValidDate(date)) {

                return (
                  <div
                    key={shortMonth}
                    className="buyplan-summary-card"
                    data-month={formattedDate}
                  >
                    {
                      <div>
                        <div className='parent_section_5'>
                          <div className='child_section'>
                            <FormGroup check className="buyplanGroup">
                              <Input type="checkbox" id={"checkboxfor" + shortMonth} />
                              <Label check for={"checkboxfor" + shortMonth}>
                                {shortMonth}
                              </Label>
                            </FormGroup>
                          </div>
                        </div>

                        <div className='parent_section_6'>
                          <div className='child_section'>
                            <Input type="text" id={"textfor" + shortMonth} />
                          </div>

                        </div>
                      </div>
                    }
                  </div>
                );

              }
            })}
          </div>
        </FormGroup>
      </ModalBody>
    </Modal>
  );
};

export default EmailPDFModal;